// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Visa: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 50 30" enableBackground="new 0 0 50 30" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M45.99,0C48.21,0,50,1.79,50,4v22c0,2.21-1.79,4-4.01,4H4.01C1.79,30,0,28.21,0,26
	V4c0-2.21,1.79-4,4.01-4H45.99z M29.91,10.07c-2.43,0-4.14,1.29-4.15,3.15c-0.02,1.37,1.22,2.14,2.15,2.59
	c0.96,0.47,1.28,0.77,1.28,1.18c-0.01,0.64-0.76,0.93-1.47,0.93c-0.98,0-1.51-0.14-2.31-0.5l-0.32-0.15l-0.34,2.13
	c0.57,0.27,1.64,0.5,2.74,0.51c2.58,0,4.26-1.28,4.28-3.26c0.01-1.09-0.65-1.91-2.06-2.59c-0.86-0.44-1.39-0.74-1.38-1.18
	c0-0.4,0.45-0.82,1.41-0.82c0.8-0.01,1.39,0.17,1.84,0.37l0.22,0.11l0.33-2.07C31.63,10.28,30.87,10.07,29.91,10.07z M38.42,10.25
	h-1.9c-0.59,0-1.03,0.17-1.29,0.79l-3.65,8.74h2.58c0,0,0.42-1.18,0.52-1.43c0.03,0,0.08,0,0.16,0l0.45,0c0.06,0,0.12,0,0.19,0
	l0.42,0c0.22,0,0.45,0,0.67,0l0.42,0c0.07,0,0.13,0,0.2,0l0.65,0c0.07,0.33,0.3,1.43,0.3,1.43h2.28L38.42,10.25z M24.74,10.24h-2.46
	l-1.54,9.54h2.46L24.74,10.24z M14.05,10.24h-3.96l-0.03,0.2c0.96,0.25,1.83,0.6,2.58,1.05l2.18,8.28l2.6,0l3.87-9.52h-2.6
	l-2.41,6.5l-0.26-1.32l-0.86-4.38C15.01,10.44,14.58,10.26,14.05,10.24L14.05,10.24z M36.69,12.82l0.17,0.82
	c0,0,0.47,2.28,0.57,2.75h-2.04c0.07-0.2,0.22-0.61,0.38-1.04l0.12-0.33c0.24-0.66,0.47-1.29,0.47-1.29
	C36.35,13.75,36.57,13.17,36.69,12.82L36.69,12.82z M12.62,11.42c1.56,0.83,2.96,2.48,3.4,4c-0.58-1.57-1.73-2.97-3.39-3.94
	L12.62,11.42z"/>
</svg>;
};

export default React.memo(Visa);
